import { createContext, useContext } from 'react';

interface DemoContextProps {
  isDemo: boolean;
}

const DemoContext = createContext<DemoContextProps>({ isDemo: false });

export const DemoProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <DemoContext.Provider value={{ isDemo: true }}>
      {children}
    </DemoContext.Provider>
  );
};

export const useDemo = () => useContext(DemoContext);
